import { useState } from 'react';
import type { FormEvent } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Logo } from '../../design-system/components/Logo';
import { ApiError } from '../../lib/apiClient';
import { useAuth } from './useAuth';

export function LoginPage() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fout, setFout] = useState<string | null>(null);
  const [bezig, setBezig] = useState(false);

  if (loading) return <div className="vs-center-page">Laden…</div>;
  // Waar de sessie afbrak terugpakken, anders gewoon de lijst.
  if (user) {
    const from = (location.state as { from?: string } | null)?.from;
    return <Navigate to={from ?? '/'} replace />;
  }

  async function submit(e: FormEvent) {
    e.preventDefault();
    setFout(null);
    setBezig(true);
    try {
      await login({ email, password });
      navigate((location.state as { from?: string } | null)?.from ?? '/', { replace: true });
    } catch (err) {
      setFout(err instanceof ApiError ? err.message : 'Inloggen mislukt');
    } finally {
      setBezig(false);
    }
  }

  return (
    <div className="vs-login">
      <div className="vs-login__card">
        <span className="vs-login__logo">
          <Logo height={36} />
        </span>
        <div>
          <div className="vs-login__eyebrow">Boodschappen</div>
          <div className="vs-login__rule" />
          <h1 className="vs-login__title">Basis op orde.</h1>
          <p className="vs-login__sub">Log in om de boodschappenlijst te openen.</p>
        </div>

        <form className="vs-login__form" onSubmit={submit} noValidate>
          <div className="vs-field">
            <label className="vs-label" htmlFor="email">
              E-mailadres
            </label>
            <input
              id="email"
              className="vs-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="naam@veerenstael.nl"
              autoComplete="username"
              required
            />
          </div>

          <div className="vs-field">
            <label className="vs-label" htmlFor="password">
              Wachtwoord
            </label>
            <input
              id="password"
              className="vs-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
              required
            />
          </div>

          {fout && (
            <div className="vs-login__error" role="alert">
              {fout}
            </div>
          )}

          <button className="vs-btn vs-btn--block" type="submit" disabled={bezig}>
            {bezig ? 'Bezig…' : 'Inloggen'}
          </button>
        </form>
      </div>
    </div>
  );
}
